<div class="parent-accounts-dialog">
  <ng-container *ngIf="!isStudent && !isFamilyMember">
    <p>{{ 'account_settings_enable_parent_accounts_info' | translate }}</p>
    <aero-button [size]="ButtonSize.LARGER" [aeroStyle]="ButtonStyle.PRIMARY" labelCode="account_settings_enable_parent_accounts"
                 (onClick)="enable()"></aero-button>
  </ng-container>

  <ng-container *ngIf="isStudent && studentAccountEnabled">
    <p>{{ 'account_settings_parents_info' | translate }}</p>
    <div class="student-code">
      <strong>{{ 'account_settings_invite_code' | translate }}</strong>
      <div class="student-code-value">
        <span id="family-invite-code">{{ account.family?.inviteCode }}</span>
        <button class="copy-student-code-button"
                type="button"
                [attr.aria-label]="'account_settings_invite_code' | translate"
                [attr.aria-describedby]="codeCopied ? 'studentcode-copied-text' : 'family-invite-code'"
                (click)="copyStudentCode()">
          <i class="far fa-clipboard" aria-hidden="true"></i>
        </button>
      </div>
      <span *ngIf="codeCopied" id="studentcode-copied-text" class="copied-message">
        {{ 'pageview_copied_to_clipboard_text' | translate }}
      </span>
    </div>
    <div *ngIf="familyMembers.length" class="member-list">
      <strong>{{ 'account_settings_connected_members' | translate }}</strong>
      <div *ngFor="let member of familyMembers" class="member-row">
        <span>{{ member.displayName }}</span>
        <button class="text-button" (click)="disconnectParent(member)">
          {{ 'account_settings_disconnect' | translate }}
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isStudent && !studentAccountEnabled">
    <p class="text-center">{{ 'account_settings_to_use_parent_view' | translate }}</p>
    <aero-button *ngIf="canUpgrade" [size]="ButtonSize.LARGER" [aeroStyle]="ButtonStyle.PRIMARY"
                 labelCode="account_settings_upgrade"
                 (onClick)="upgrade()"></aero-button>
  </ng-container>

  <ng-container *ngIf="isFamilyMember">
    <strong>{{ 'account_settings_students' | translate }}</strong>
    <div *ngFor="let student of students" class="member-row">
      <span>
        {{ student.displayName }}
        <a class="view-profile-link" (click)="viewProfile(student.username, $event)">
          <i class="fas fa-eye" aria-hidden="true"></i>
          <span>{{ 'dashboard_account_hover_view_profile' | translate }}</span>
        </a>
      </span>
      <button class="text-button" (click)="disconnectStudent(student)">
        {{ 'account_settings_disconnect' | translate }}
      </button>
    </div>
    <div class="family-actions">
      <aero-button [size]="ButtonSize.LARGER" [aeroStyle]="ButtonStyle.PRIMARY" labelCode="account_settings_add_student"
                   (onClick)="addStudent()"></aero-button>
      <aero-button [size]="ButtonSize.LARGER" [aeroStyle]="ButtonStyle.ALERT" labelCode="account_settings_disable_parent_accounts"
                   (onClick)="disable()"></aero-button>
    </div>
  </ng-container>
</div>
